const Q = require('q');
const __request = require(`./__request/__request_contentType_json`);

const web_credit_getEnum = function (pParameter) {
    if (!pParameter) pParameter = {};

    // 获取系统枚举：http://tour-alpha.yinzhilv.com/doc.html#/yinzhilv_travel/credit-account-controller/getEnumUsingPOST

    return Q.when()
        .then(function () {
            return __request({
                method: 'POST',
                urlSuffix: '/web/credit/getEnum',
                data: pParameter,
            });
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;

};

module.exports = web_credit_getEnum;